import { useAppStore } from '@/shared/store/app.store.ts'
import { useScriptStore } from '@/shared/store/script.store.ts'
import SessionService from '@/features/session/data/session.service.ts'
import { mapSessionDtoToSession } from '@/features/session/domain/mappers/session.mapper.ts'
import { useSpeechStore } from '@/shared/store/speech.store.ts'
import useTracksStore from '@/shared/store/tracks.store.tsx'

export const patchSession = async (audioformId?: string): Promise<void> => {
  const { session } = useAppStore.getState()
  if (!session) return

  const { scripts } = useScriptStore.getState()
  const { speeches } = useSpeechStore.getState()
  const timeline = useTracksStore.getState().getSnapshot()

  const sessionDto = await SessionService.patchSession({
    ...session,
    ...(audioformId ? { audioformId } : {}),
    state: { version: 'v0.1', scripts, speeches, timeline },
  })

  useAppStore.getState().setSession(mapSessionDtoToSession(sessionDto))
}
